import { MdCheckCircle, MdCancel, MdSchedule, MdEditNote } from "react-icons/md";

/**
 * French labels for legal document types.
 * Maps API type keys to human-readable labels.
 */
export const TYPE_LABELS = {
    privacy_policy: "Politique de confidentialité",
    terms_artist: "CGU Artistes",
    terms_auditor: "CGU Auditeurs",
    legal_notices: "Mentions légales",
    subscription_rules: "Règles abonnement",
    certification_policy: "Politique certification",
    collaboration_charter: "Charte collaboration",
    refund_policy: "Politique remboursement",
    cookie_policy: "Politique cookies"
};

/**
 * French labels for target role values.
 */
export const ROLE_LABELS = { artist: "Artiste", auditor: "Auditeur", all: "Tous" };

/**
 * Status badge configuration with react-icons, colors, and labels.
 * Used in both list and detail views.
 */
export const STATUS_MAP = {
    active: { label: "Actif", color: "#4caf50", bgColor: "rgba(76,175,80,0.15)", Icon: MdCheckCircle },
    inactive: { label: "Inactif", color: "#f44336", bgColor: "rgba(244,67,54,0.15)", Icon: MdCancel },
    scheduled: { label: "Programmé", color: "#ff9800", bgColor: "rgba(255,152,0,0.15)", Icon: MdSchedule },
    draft: { label: "Brouillon", color: "#2196f3", bgColor: "rgba(33,150,243,0.15)", Icon: MdEditNote }
};

/**
 * Returns the French label for a document type key.
 * @param {string} type - The document type key
 * @returns {string} The localized label
 */
export function getTypeLabel(type) {
    return TYPE_LABELS[type] || type;
}

/**
 * Returns status badge configuration from the status string.
 * @param {string} status - The document status (draft/scheduled/active/inactive)
 * @returns {object} Config with label, color, bgColor, Icon
 */
export function getStatusConfig(status) {
    return STATUS_MAP[status] || STATUS_MAP.draft;
}
